import { DataHeader, DataSource, HorizontalSpacer, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutServiceIncidentListDetail extends Layout {
    dataheader1: DataHeader;
    horizontalspacer1: HorizontalSpacer;
    panelGeneralLeft: Panel;
    panelGeneralMiddle: Panel;
    panelGeneralRight: Panel;
    sourceServiceIncidentList: DataSource;
    sourceServiceIncidentOrders: DataSource;
    sourceServiceIncidentPostHist: DataSource;
    sourceServiceIncidentStop: DataSource;
    switchAppointmentRequired: Switch;
    switchFaultOfCarrierOrDriver: Switch;
    switchReportable: Switch;
    switchReviewRequired: Switch;
    tabGeneral: Tab;
    tabHistory: Tab;
    tabStops: Tab;
    tableHistory: Table;
    tableStops: Table;
    tabsetGeneral: Tabset;
    textboxBol: Textbox;
    textboxCausedByType: Textbox;
    textboxCustomerId: Textbox;
    textboxDelayCode: Textbox;
    textboxDispatcherUserId: Textbox;
    textboxDriverId: Textbox;
    textboxDspComment: Textbox;
    textboxEnteredDate: Textbox;
    textboxEnteredUserId: Textbox;
    textboxFleetManager: Textbox;
    textboxMinutesLate: Textbox;
    textboxMovementId: Textbox;
    textboxName: Textbox;
    textboxOperationsUser: Textbox;
    textboxOrderId: Textbox;
    textboxOverridePayeeId: Textbox;
    textboxPartnerName: Textbox;
    textboxReviewedBy: Textbox;
    textboxReviewedDate: Textbox;
    textboxStatus: Textbox;
    textboxStopNo: Textbox;
    textboxTerminalId: Textbox;
    textboxTractorId: Textbox;
    textboxTrailerId: Textbox;
    textboxUserId: Textbox;
}
